const topLocation = (() => {
  const pageTop = (document.getElementById("pageTop") != null);
  if (pageTop) {



    let sW = window.innerWidth;

    const secLocation = document.getElementById('jsSecLocation');

    const mainImgWrap = secLocation.querySelector('.js-main-img-wrap');

    const mainImgArea = secLocation.querySelector('.js-main-img-area');

    const mainImgBoxLeft = mainImgWrap.querySelector('.js-main-img-box.left');
    const mainImgBoxRight = mainImgWrap.querySelector('.js-main-img-box.right');

    const mainImgBoxLeftImg = mainImgWrap.querySelector('.js-main-img-box.left .js-img');
    const mainImgBoxRightImg = mainImgWrap.querySelector('.js-main-img-box.right .js-img');

    const subImgBox = mainImgWrap.querySelector('.js-sub-img-box');

    const triggerWrap = secLocation.querySelector('.js-trigger-wrap');
    const triggerAreas = triggerWrap.querySelectorAll('.js-trigger-area');

    const copyWrap = secLocation.querySelector('.js-copy-wrap');



    let to1 = gsap.to(mainImgWrap, {
      scrollTrigger: {
        trigger: mainImgWrap,
        start: '0% 0%',
        endTrigger: triggerAreas[1],
        end: '100% 100%',
        pin: true,
        // markers: true
      }
    });

    let to2 = gsap.to(copyWrap, {
      scrollTrigger: {
        trigger: copyWrap,
        start: '0% 0%',
        endTrigger: triggerAreas[1],
        end: '100% 100%',
        pin: true,
        // markers: true
      }
    });


    let mainImgAreaY
    if (sW > 750) {
      mainImgAreaY = 200
    } else {
      mainImgAreaY = 100
    }
    let to3 = gsap.to(mainImgArea, {
      y: mainImgAreaY,
      scrollTrigger: {
        trigger: triggerAreas[1],
        start: '100% 100%',
        endTrigger: triggerAreas[1],
        end: '100% 0%',
        scrub: 0.5,
        // markers: true
      }
    });


    let leftImgW
    let leftImgH
    if (sW > 750) {
      leftImgW = `${266 / 1300 * 200}%`
      leftImgH = `${286 / 700 * 100}%`
    } else {
      leftImgW = '36rem'
      leftImgH = '29rem'
    }
    let to4 = gsap.to(mainImgBoxLeftImg, {
      width: leftImgW,
      height: leftImgH,
      scrollTrigger: {
        trigger: triggerAreas[0],
        start: '0% 0%',
        endTrigger: triggerAreas[1],
        end: '100% 100%',
        // pin: true,
        scrub: 0.5,
        onEnter: () => mainImgBoxLeftImg.classList.add('on'),
        // onLeave: () => console.log("onLeave"),
        // onEnterBack: () => console.log("onEnterBack"),
        onLeaveBack: () => mainImgBoxLeftImg.classList.remove('on'),
        // markers: true
      }
    });

    let rightImgW
    let rightImgH
    if (sW > 750) {
      rightImgW = `${266 / 1300 * 200}%`
      rightImgH = `${286 / 700 * 100}%`
    } else {
      rightImgW = '36rem'
      rightImgH = '29rem'
    }
    let to5 = gsap.to(mainImgBoxRightImg, {
      width: rightImgW,
      height: rightImgH,
      scrollTrigger: {
        trigger: triggerAreas[0],
        start: '0% 0%',
        endTrigger: triggerAreas[1],
        end: '100% 100%',
        scrub: 0.5,
        onEnter: () => mainImgBoxRightImg.classList.add('on'),
        // onLeave: () => console.log("onLeave"),
        // onEnterBack: () => console.log("onEnterBack"),
        onLeaveBack: () => mainImgBoxRightImg.classList.remove('on'),
        // markers: true
      }
    });


    let to6 = gsap.to(subImgBox, {
      scale: 1,
      scrollTrigger: {
        trigger: triggerAreas[0],
        start: '0% 0%',
        endTrigger: triggerAreas[1],
        end: '100% 100%',
        scrub: 0.5,
        // markers: true
      }
    });


    let target = document.querySelector('body');
    let observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        to1.scrollTrigger.refresh()
        to2.scrollTrigger.refresh()
        to3.scrollTrigger.refresh()
        to4.scrollTrigger.refresh()
        to5.scrollTrigger.refresh()
        to6.scrollTrigger.refresh()
        // console.log('comParallax refresh');
      });
    });
    observer.observe(target);




  }
})();
export default topLocation;